var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBackButton),expression:"showBackButton"}],staticClass:"back-button d-md-block d-lg-none"},[_c('span',{on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"fa fa-arrow-left"}),_vm._v(" Back\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e17ed35e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/goback.vue
// module id = null
// module chunks = 